import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-twitch',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Twitch icon</title><path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/></svg>`,
    styles: []
})
export class SimpleIconsTwitchComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#9146FF';
    @Input() className: string = 'simple-icons-twitch'
    constructor() {}
    ngOnInit(): void {}
}
